import React, { useState, useEffect, useContext } from "react";
import {
  Card,
  Select,
  Row,
  Col,
  Popconfirm,
  Typography,
  Badge,
  Button,
  Radio,
  Modal,
  Tabs,
  notification,
  TimePicker,
  Space,
  Form,
} from "antd";
import moment from "moment";
import _ from "lodash";
import { BlankSpace, PageContainer } from "../../component/Xcomponent";
import { connect } from "react-redux";

// Style
import {
  CloseCircleOutlined,
  CheckOutlined,
  PlusCircleOutlined,
  DeleteOutlined,
  PushpinTwoTone,
  CoffeeOutlined,
  PlusCircleFilled,
} from "@ant-design/icons";
import {
  AddSlotButton,
  DayButton,
  DaySlotDiv,
  SelectBox,
  SlotView,
  SlotViewDelete,
  TimePickerBox,
  TimeSlotCard,
  TimeSlotDiv,
  XCalendar,
} from "./ScheduleStyle";

//Actions
import {
  getScheduleTimingList,
  getScheduleTimingListReset,
} from "../../action/getScheduleTimeListAction";
import {
  saveScheduleTiming,
  saveScheduleTimingReset,
} from "../../action/saveScheduleTimingAction";
import {
  getAllScheduleTimingList,
  getAllScheduleTimingListReset,
} from "../../action/getAllScheduleTimingListAction";
import {
  deleteScheduleTimeSlot,
  deleteScheduleTimeSlotReset,
} from "../../action/deleteScheduleTimeSlotAction";

// Others
import ScheduleTimingCustomize from "../../component/ScheduleTimingCustomize/ScheduleTimingCustomize";
import { timeSlotFormat } from "../../utils";
import "./Schedule.css";

import { parse } from "@fortawesome/fontawesome-svg-core";
import HeaderContext from "../../context/HeaderContext";

const Schedule = (props) => {
  //Variables

  const {
    saveScheduleTiming,
    saveScheduleTimingState,
    saveScheduleTimingReset,
    deleteScheduleTimeSlot,
    deleteScheduleTimeSlotState,
    deleteScheduleTimeSlotReset,
    getAllScheduleTimingList,
    getAllScheduleTimingListState,
    getAllScheduleTimingListReset,
    getScheduleTimingList,
    getScheduleTimingListState,
    getScheduleTimingListReset,
    getDoctorDetailState,
  } = props;
  const { TabPane } = Tabs;
  const allDayInitialState = {
    Sunday: false,
    Monday: false,
    Tuesday: false,
    Wednesday: false,
    Thursday: false,
    Friday: false,
    Saturday: false,
  };
  const [allday, setDay] = useState(allDayInitialState);

  const [selectedDays, setSelectedDays] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const initialTime = {
    start_time: null,
    end_time: null,
  };
  const [value, setValue] = useState(initialTime);

  // minimum time slots of 15 mins should be set (tentative can change as pr the requirement)
  const [duration, setDuration] = useState(null);

  const [timeSlots, setTimeSlots] = useState([]);
  const [calSlots, setCalSlots] = useState([]);
  const [timeSlotForCallAPi, setTimeSlotForCallAPi] = useState([]);
  const [tag, setTag] = useState(null);
  const [timeSlotDay, setTimeSlotDay] = useState("Monday");
  const [values, setValues] = useState();
  let dvday = new Date().getDate();
  const [valueday, setValueday] = useState(dvday);
  const [month, setMonth] = useState(parseInt(moment().format("M")));
  const [year, setYear] = useState(parseInt(moment().format("Y")));
  const [view, setView] = useState({
    visible: false,
    parameters: {},
    date: moment(),
  });
  const [selectedDate, setSelectedDate] = useState(moment());
  const [isDateAvailable, setIsDateAvailable] = useState(true);
  const { setTitle } = useContext(HeaderContext);
  setTitle("Manage Schedule");

  useEffect(() => {
    getAllScheduleTimingListData();
    let ds = new Date();
    const paramete = {
      day: new Date().toLocaleDateString("en-us", { weekday: "long" }),
      date: moment(new Date()).format("YYYY-MM-DD"),
    };
    getScheduleTimingList(paramete);
    return () => {
      moment.updateLocale("en", {
        weekdaysMin: ["S", "M", "T", "W", "T", "F", "S"],
      });
    };
  }, []);

  useEffect(() => {
    if (getAllScheduleTimingListState.apiState === "success") {
      //when there are customized slots
      setTag(true);

      //let ds = getAllScheduleTimingListState.list.schedule_timing_slot.find(x => x.day === new Date().toLocaleDateString('en-us', { weekday: "long" }))
      //console.log("ds", ds)
    }
    if (getAllScheduleTimingListState.apiState === "error") {
      notification["error"]({
        message: getAllScheduleTimingListState.message,
        placement: "topRight",
      });
    }
  }, [getAllScheduleTimingListState]);

  const getListData = (value) => {
    let listData;
    let datecurrent = new Date();
    switch (value.date()) {
      case valueday:
        listData = [
          {
            type: "Time Slot",
            content: values,
          },
        ];
        break;

      default:
    }
    return listData || [];
  };
  //Post request
  useEffect(() => {
    if (saveScheduleTimingState.apiState === "success") {
      saveScheduleTimingReset();
      notification["success"]({
        message: saveScheduleTimingState.message,
        placement: "topRight",
      });
      setSelectedDays([]);
      setTimeSlots([]);
      setDuration(null);
      setValue(initialTime);
      setDay(allDayInitialState);
      setIsModalVisible(false);
      getAllScheduleTimingListData();
    }
    if (saveScheduleTimingState.apiState === "error") {
      saveScheduleTimingReset();
      notification["error"]({
        message: saveScheduleTimingState.message,
        placement: "topRight",
      });
    }
  }, [saveScheduleTimingState]);

  useEffect(() => {
    if (deleteScheduleTimeSlotState.apiState === "success") {
      deleteScheduleTimeSlotReset();
      notification["success"]({
        message: deleteScheduleTimeSlotState.message,
        placement: "topRight",
      });
      if (timeSlotForCallAPi.length === 0) {
        getAllScheduleTimingListData();
      }
      setTimeSlotForCallAPi([]);
    }
    if (deleteScheduleTimeSlotState.apiState === "error") {
      deleteScheduleTimeSlotReset();
      getAllScheduleTimingListData();
      notification["error"]({
        message: deleteScheduleTimeSlotState.message,
        placement: "topRight",
      });
    }
  }, [deleteScheduleTimeSlotState]);

  // Function

  const getAllScheduleTimingListData = () => {
    getAllScheduleTimingList();
  };

  const dayClicked = (day, value) => {
    setDay({ ...allday, [day]: !value });

    if (!value) {
      let data = selectedDays;
      data.push(day);
      setSelectedDays(data);
    } else {
      _.remove(selectedDays, (days) => {
        return days === day;
      });
      setSelectedDays(selectedDays);
    }
  };

  const { Option } = Select;

  // Set Duration time
  const onChangeDuration = (value) => {
    setDuration(value);
  };

  // For drawer

  const onPanelChange = (value, mode) => {
    // alert("ASD")
    setView({ visible: false });
  };

  const onSelect = (value) => {
    console.log("find", value);
    // alert("ASD")
    let sendDay = "";
    const dayNum = value.weekday();
    const date = value.format("YYYY-MM-DD");
    console.log(date);
    const selectedMonth = parseInt(date.split("-")[1],10);
    const selectedDateMonth = value._d.getMonth() + 1;
    console.log(selectedMonth, selectedDateMonth);
    if (selectedMonth === selectedDateMonth) {
      // Only update the selected date if it's in the same month
      setView({ date: value._d });
      if (dayNum === 1) {
        sendDay = "Monday";
      }
      if (dayNum === 2) {
        sendDay = "Tuesday";
      }
      if (dayNum === 3) {
        sendDay = "Wednesday";
      }
      if (dayNum === 4) {
        sendDay = "Thursday";
      }
      if (dayNum === 5) {
        sendDay = "Friday";
      }
      if (dayNum === 6) {
        sendDay = "Saturday";
      }
      if (dayNum === 0) {
        sendDay = "Sunday";
      }
      const parameters = {
        day: sendDay,
        date: date,
      };
      setView({ parameters: parameters, visible: true, date: value });
      getScheduleTimingList(parameters);
      setValueday(new Date(value).getDate());
      setSelectedDate(value);
  
      dateCellRender(value);
      if (getScheduleTimingListState.apiState === "success") {
        if (getScheduleTimingListState.list?.schedule_timing_slot.length > 0) {
          setValues(
            getScheduleTimingListState.list.schedule_timing_slot[0].time_slots
              .length
          );
        }
      }
    }
  };
  // useEffect(() => {
  //   if (getScheduleTimingListState.apiState === "success") {
  //     if (getScheduleTimingListState.list?.schedule_timing_slot.length > 0) {
  //       setValues(
  //         getScheduleTimingListState.list.schedule_timing_slot[0].time_slots
  //           .length
  //       );
  //     }
  //   }
  // }, [getScheduleTimingListState]);
  const showModal = () => {
    setIsModalVisible(true);
  };

  const sendData = () => {
    if (value.start_time === null || value.end_time === null) {
      notification["error"]({
        message: "Please choose correct time",
        placement: "topRight",
      });
      return true;
    }

    var start_time = value.start_time.format("HH:mm");
    var end_time = value.end_time.format("HH:mm");
    if (start_time === end_time) {
      notification["error"]({
        message: "Please choose different time",
        placement: "topRight",
      });
      return true;
    }

    if (start_time > end_time) {
      notification["error"]({
        message: "End time should be greater then start time",
        placement: "topRight",
      });
      return true;
    }

    if (selectedDays.length === 0) {
      notification["error"]({
        message: "Please select at least one day",
        placement: "topRight",
      });
      return true;
    }

    // end_date_time = moment(value.end_time, "DD-MM-YYYY HH:mm'");
    // start_date_time = moment(value.start_time, "DD-MM-YYYY HH:mm'");
    // var duration_diff = moment.duration(end_date_time.diff(start_date_time,'minutes'));
    // var total_mins = parseInt(duration_diff.asMinutes());

    var total_mins = (value.end_time.unix() - value.start_time.unix()) / 60;

    if (duration == null || duration == 0) {
      if (total_mins < 15) {
        notification["error"]({
          message: "Please select at least 15 minutes slot",
          placement: "topRight",
        });
        return true;
      }
    } else {
      if (total_mins % duration != 0) {
        notification["error"]({
          message:
            "Can't divide the slots as per selected duration. Please select valid start and end time",
          placement: "topRight",
        });
        return true;
      }
    }

    // Commented out as it matches only same minutes format (might be added for 1 hour time slots scenarion)
    // In place of this made two changes
    // --> 1. Added time slots minimum should be 15 mins not less than that
    // --> 2. if the duratn is selected then the end time is auto populated

    // if (duration !== null) {
    //   if (+value.start_time.format("mm") !== +value.end_time.format("mm")) {
    //     notification["error"]({
    //       message: "Please choose correct time format",
    //       placement: "topRight",
    //     });
    //     return true;
    //   }
    // }

    // Extra affords
    var end_date_time = "";
    var start_date_time = "";
    // if (value.end_time.format("HH") === "00") {
    //   end_date_time = moment(value.end_time, "DD-MM-YYYY HH:mm'").add(
    //     1,
    //     "days"
    //   );
    //   start_date_time = moment(value.start_time, "DD-MM-YYYY HH:mm'");
    // } else {
    //   end_date_time = moment(value.end_time, "DD-MM-YYYY HH:mm'");
    //   start_date_time = moment(value.start_time, "DD-MM-YYYY HH:mm'");
    // }

    end_date_time = moment(value.end_time, "DD-MM-YYYY HH:mm'");
    start_date_time = moment(value.start_time, "DD-MM-YYYY HH:mm'");
    // var duration_diff = moment.duration(end_date_time.diff(start_date_time));
    // var hours = parseInt(duration_diff.asHours());
    // // duration in minutes
    // var minutes = parseInt(duration_diff.asMinutes()) % 60;

    var hours = end_date_time.diff(start_date_time, "hours");
    var minutes = end_date_time.diff(start_date_time, "minutes") % 60;

    let totalHours = hours * 60 + minutes;

    // var duration_diff = moment.duration(value.end_time.diff(value.start_time));
    // // duration in hours
    // var hours = parseInt(duration_diff.asHours());

    // // duration in minutes
    // var minutes = parseInt(duration_diff.asMinutes()) % 60;

    // let totalHours = ((hours * 60) + minutes)
    // console.log("hello end_time", value.end_time)
    // console.log("hello hours", hours)
    // console.log("hello minutes", minutes)
    // console.log("hello", totalHours)
    let currentHours = 0;
    if (duration !== null) {
      let i = 0;
      do {
        if (i === 0) {
          timeSlots.push({
            start_time: value.start_time
              .add(moment.duration(0, "minutes"))
              .format("HH:mm"),
            end_time: value.start_time
              .add(moment.duration(+duration, "minutes"))
              .format("HH:mm"),
          });
        } else {
          timeSlots.push({
            start_time: value.start_time
              .add(moment.duration(+duration, "minutes"))
              .format("HH:mm"),
            end_time: value.start_time
              .add(moment.duration(+duration, "minutes"))
              .format("HH:mm"),
          });
        }
        currentHours += +duration;
      } while (totalHours > currentHours);
      setTimeSlots(timeSlots);
    } else {
      timeSlots.push({ start_time: start_time, end_time: end_time });
      setTimeSlots(timeSlots);
    }

    if (timeSlots.length === 0) {
      notification["error"]({
        message: "Please choose correct time",
        placement: "topRight",
      });
      return true;
    }

    let schedule = {
      day_slots: [],
    };
    selectedDays.map((day) => {
      schedule.day_slots.push({
        day: day,
        time_slots: timeSlots,
      });
    });
    saveScheduleTiming(schedule);
  };

  const onChangeRange = (time, name) => {
    setValue({ ...value, [name]: time });

    // if(name=="start_time")
    // {
    //   let duratin = duration > 0 ? duration : 15
    //   setValue({ ...value,
    //     [name]: time,
    //     ['end_time']: moment(time).add(duratin, "minutes")
    //   });
    // }
    // else
    // {
    //   setValue({ ...value, [name]: time });
    // }
  };

  const deleteTimeSlot = (data, item) => {
    _.remove(data.time_slots, (time_slot) => {
      return time_slot === item;
    });
    deleteScheduleTimeSlot(data);
    setTimeSlotForCallAPi(data.time_slots);
  };

  const handleCancel = () => {
    setSelectedDays([]);
    setTimeSlots([]);
    setValue(initialTime);
    setDay(allDayInitialState);
    setIsModalVisible(false);
    setDuration(null);
  };

  useEffect(() => {
    if (getScheduleTimingListState.apiState === "success") {
      //when there are customized slots
      if (getScheduleTimingListState.list?.schedule_timing_slot.length > 0) {
        console.log("Parvez this is executed");
        setTag(true);
        setCalSlots(
          getScheduleTimingListState.list.schedule_timing_slot[0].time_slots
        );
        setValues(
          getScheduleTimingListState.list.schedule_timing_slot[0].time_slots
            .length
        );
      }
    }
    if (getScheduleTimingListState.apiState === "error") {
      notification["error"]({
        message: getScheduleTimingListState.message,
        placement: "topRight",
      });
    }
  }, [getScheduleTimingListState]);

  const dateCellRender = (value) => {
    const listData = getListData(value);
    return (
      <>
        {listData.map((item) => (
          <div key={item.content} className="event">
            <div className="circle">{isDateAvailable ? item.content : 0}</div>
            <div className="type">{item.type}</div>
          </div>
        ))}
      </>
    );
  };
  const openTimeSlot = (day) => {};
  useEffect(() => {
    let data = true;
    (async () => {
      await data;
    })();
  }, []);

  const daysOfWeek = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
  const getDaysOfWeekStartingFromToday = () => {
    const currentDayIndex = moment().day();
    const daysOfWeekStartingFromToday = _.range(7).map((index) => {
      const dayIndex = (currentDayIndex + index) % 7;
      return daysOfWeek[dayIndex];
    });
    return daysOfWeekStartingFromToday;
  };

  return (
    <div>
      {
        getDoctorDetailState.apiState==="success"&&getDoctorDetailState.data.is_dcp_activated=="Yes" ? 
        <PageContainer>
          {/* Add time slot modal */}
          <Modal
            title="Add Time Slots"
            visible={isModalVisible}
            onCancel={handleCancel}
            width="830px"
            footer={[
              <Button
                className="borderNonPrimary"
                style={{ borderRadius: 7 }}
                key="back"
                onClick={handleCancel}
              >
                Cancel
              </Button>,
              <Button
                className="borderPrimary"
                style={{ borderRadius: 7 }}
                key="submit"
                type="primary"
                onClick={sendData}
              >
                {/* send parameter as selected day */}
                Submit
              </Button>,
            ]}
          >
            <div className="scheduleaddTimePicker2">
              <DaySlotDiv style={{ justifyContent: "flex-start" }}>
                <DayButton
                  className={allday.Monday ? "selected" : ""}
                  onClick={() => dayClicked("Monday", allday.Monday)}
                >
                  MON
                </DayButton>
                <DayButton
                  className={allday.Tuesday ? "selected" : ""}
                  onClick={() => dayClicked("Tuesday", allday.Tuesday)}
                >
                  TUE
                </DayButton>
                <DayButton
                  className={allday.Wednesday ? "selected" : ""}
                  onClick={() => dayClicked("Wednesday", allday.Wednesday)}
                >
                  WED
                </DayButton>
                <DayButton
                  className={allday.Thursday ? "selected" : ""}
                  onClick={() => dayClicked("Thursday", allday.Thursday)}
                >
                  THU
                </DayButton>
                <DayButton
                  className={allday.Friday ? "selected" : ""}
                  onClick={() => dayClicked("Friday", allday.Friday)}
                >
                  FRI
                </DayButton>
                <DayButton
                  className={allday.Saturday ? "selected" : ""}
                  onClick={() => dayClicked("Saturday", allday.Saturday)}
                >
                  SAT
                </DayButton>
                <DayButton
                  className={allday.Sunday ? "selected" : ""}
                  onClick={() => dayClicked("Sunday", allday.Sunday)}
                >
                  SUN
                </DayButton>
              </DaySlotDiv>
              <BlankSpace />
              <Space>
                <SelectBox
                  showSearch
                  placeholder="Select a duration"
                  optionFilterProp="children"
                  onChange={onChangeDuration}
                  value={duration}
                  // onSearch={onSearch}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                    0
                  }
                  size="large"
                >
                  {/*<Option value="60">1 Hour</Option>*/}
                  {/*<Option value="120">2 Hour</Option>*/}
                  {/*<Option value="180">3 Hour</Option>*/}
                  {/*<Option value="240">4 Hour</Option>*/}
                  {/*<Option value="300">5 hour</Option>*/}
                  {/* <Option value="15">15 Mins</Option> */}
                  <Option value="20">20 Mins</Option>
                  <Option value="30">30 Mins</Option>
                  <Option value="45">45 Mins</Option>
                  <Option value="60">60 Mins</Option>
                  {/* <Option value="90">90 Mins</Option> */}
                  {/* <Option value="120">120 Mins</Option> */}
                </SelectBox>
                <TimePickerBox
                  className="scheduleaddTimePicker2"
                  value={value.start_time}
                  onChange={(time) => onChangeRange(time, "start_time")}
                  format="h:mm A"
                  style={{ width: 140 }}
                  placeholder="Start Time"
                  size="large"
                />
                <TimePickerBox
                  value={value.end_time}
                  onChange={(time) => onChangeRange(time, "end_time")}
                  format="h:mm A"
                  style={{ width: 140 }}
                  placeholder="End Time"
                  size="large"
                />
              </Space>
              <br />
              <br />

              {/* <div style={{ width: '100%' }}>
                  <Space>
                    <Button type={allday.Sunday ? 'primary' : 'default'} onClick={() => dayClicked('Sunday', allday.Sunday)}>Sunday</Button>
                    <Button type={allday.Monday ? 'primary' : 'default'} onClick={() => dayClicked('Monday', allday.Monday)}>Monday</Button>
                    <Button type={allday.Tuesday ? 'primary' : 'default'} onClick={() => dayClicked('Tuesday', allday.Tuesday)}>Tuesday</Button>
                    <Button type={allday.Wednesday ? 'primary' : 'default'} onClick={() => dayClicked('Wednesday', allday.Wednesday)}>Wednesday</Button>
                    <Button type={allday.Thursday ? 'primary' : 'default'} onClick={() => dayClicked('Thursday', allday.Thursday)}>Thursday</Button>
                    <Button type={allday.Friday ? 'primary' : 'default'} onClick={() => dayClicked('Friday', allday.Friday)}>Friday</Button>
                    <Button type={allday.Saturday ? 'primary' : 'default'} onClick={() => dayClicked('Saturday', allday.Saturday)}>Saturday</Button>
                  </Space>
                </div> */}
            </div>
          </Modal>
          
          {/* Show all slots by day */}
          <div style={{ width: "100%", justifyContent: "flex-start" }}>
            <Row gutter={[16, 16]}>
              <Col xl={24}>
                <Row>
                  <TimeSlotCard
                    title="Time Slots"
                    loading={getScheduleTimingListState.apiState === "loading"}
                    extra={
                      <AddSlotButton>
                        <Button
                          className="borderHoverNone"
                          size="large"
                          style={{ color: "#000",borderColor: "none"}}
                          type="link"
                          onClick={showModal}
                        >
                          {" "}
                          Add Time Slot{" "}
                        </Button>
                        <Button
                          className="borderHoverNone"
                          size="large"
                          type="link"
                          style={{
                            borderLeft: "1px solid #F0F0F0",
                            padding: "7.9px 15px",
                          }}
                          onClick={showModal}
                        >
                          {" "}
                          <PlusCircleFilled
                            style={{ color: "#883DA9", fontSize: 22 }}
                          />
                        </Button>
                      </AddSlotButton>
                    }
                  >
                    <DaySlotDiv>
                      {getAllScheduleTimingListState.apiState === "success" &&
                        !_.isEmpty(getAllScheduleTimingListState.list) &&
                        getDaysOfWeekStartingFromToday().map(
                          (day) => (
                            <>
                              <DayButton
                                key={day}
                                className={
                                  timeSlotDay === day ? "selected" : ""
                                }
                                onClick={() => setTimeSlotDay(day)}
                              >
                                {day.substring(0, 3)}
                              </DayButton>
                            </>
                          )
                        )}
                    </DaySlotDiv>
                    <TimeSlotDiv>
                      {getAllScheduleTimingListState.apiState === "success" &&
                        !_.isEmpty(getAllScheduleTimingListState.list) &&
                        getAllScheduleTimingListState.list.schedule_timing_slot.map(
                          (data) => (
                            <>
                              <Space style={{ flexFlow: "wrap" }}>
                                {data.time_slots.map((item, i) => (
                                  <SlotView
                                    key={i}
                                    style={{
                                      display:
                                        timeSlotDay === data.day
                                          ? "block"
                                          : "none",
                                    }}
                                  >
                                    <Space>
                                      <div>
                                        {timeSlotFormat(item.start_time)} -{" "}
                                        {timeSlotFormat(item.end_time)}{" "}
                                      </div>
                                      <Popconfirm
                                        title="Are you sure?"
                                        onConfirm={() =>
                                          deleteTimeSlot(data, item)
                                        }
                                        okText="Delete"
                                        cancelText="Cancel"
                                        okType="danger"
                                      >
                                        <SlotViewDelete>
                                          <CloseCircleOutlined
                                            style={{ color: "#883DA9"}}
                                          />
                                        </SlotViewDelete>
                                      </Popconfirm>
                                    </Space>
                                  </SlotView>
                                ))}
                              </Space>
                            </>
                          )
                        )}
                    </TimeSlotDiv>
                  </TimeSlotCard>
                </Row>
                <br />
                <Row>
                  <XCalendar
                    picker="month"
                    value={selectedDate}
                    onSelect={onSelect}
                    onPanelChange={onPanelChange}
                    locale={moment.updateLocale("en", {
                      weekdaysMin: [
                        "Sun",
                        "Mon",
                        "Tue",
                        "Wed",
                        "Thu",
                        "Fri",
                        "Sat",
                      ],
                    })}
                    dateCellRender={dateCellRender}
                    headerRender={({ value, type, onChange, onTypeChange }) => {
                      const start = 0;
                      const end = 12;
                      const monthOptions = [];
                      const { Group, Button } = Radio;
                      const { Title } = Typography;
                      const current = value?.clone();
                      const localeData = value?.localeData();
                      const months = [];
                      for (let i = 0; i < 12; i++) {
                        current.month(i);
                        months.push(localeData.monthsShort(current));
                      }
                      for (let index = start; index < end; index++) {
                        monthOptions.push(
                          <Select.Option className="month-item" key={`${index}`}>
                            {months[index]}
                          </Select.Option>
                        );
                      }
                      const month = value?.month();
                      const year = value?.year();
                      const options = [];
                      for (let i = year - 10; i < year + 10; i += 1) {
                        options.push(
                          <Select.Option key={i} value={i} className="year-item">
                            {i}
                          </Select.Option>
                        );
                      }
                      return (
                        <div className="mon_year" style={{ padding: 20 }}>
                          <Row type="flex" justify="space-between">
                            <Col>
                              <Space>
                                <SelectBox
                                  size="large"
                                  dropdownMatchSelectWidth={false}
                                  value={String(month)}
                                  onChange={(selectedMonth) => {
                                    // const newValue = value.clone();
                                    // newValue.month(parseInt(selectedMonth, 10));
                                    value.month(parseInt(selectedMonth, 10));
                                    setMonth(selectedMonth);
                                    // onChange(newValue);
                                  }}
                                >
                                  {monthOptions}
                                </SelectBox>
                                {/* <SelectBox
                                  size="large"
                                  dropdownMatchSelectWidth={false}
                                  className="my-year-select"
                                  onChange={(newYear) => {
                                    const now = value.clone().year(newYear);
                                    value.month(parseInt(newYear, 10));
                                    setYear(newYear);
                                    // onChange(now);
                                  }}
                                  value={String(year)}
                                >
                                  {options}
                                </SelectBox> */}
                              </Space>
                            </Col>
                            {/* <Col>
                              <Group
                                size="large"
                                onChange={(e) => {
                                  console.log(e.target.value);
                                  onTypeChange(e.target.value)}}
                                value={type}
                              >
                                <Button value="month" size="medium">
                                  Month
                                </Button>
                                <Button value="year" size="medium">
                                  Year
                                </Button>
                              </Group>
                            </Col> */}
                          </Row>
                        </div>
                      );
                    }}
                    disabledDate={(current) => {
                      const startOfDay = new Date();
                      startOfDay.setHours(0, 0, 0, 0);
                      return current && current< startOfDay;
                    }}
                  />
                  <ScheduleTimingCustomize
                    className="scheduleDrwerIcon"
                    id="scheduleDrwerIcon"
                    parameters={view.parameters}
                    visible={view.visible}
                    onClose={() =>
                      setView({ ...view, ["visible"]: false, ["parameters"]: {} })
                    }
                    setIsDateAvailable={setIsDateAvailable}
                    dateCellRender={dateCellRender}
                    selectedDate={selectedDate}
                  />
                </Row>
              </Col>
            </Row>
          </div>
        </PageContainer>
        :
        <PageContainer>
          <h6>Access Not Authorized</h6>
        </PageContainer>
      }
    </div>
  );
};

const mapStateToProps = (state) => ({
  getDoctorDetailState: state.getDoctorDetail,
  getScheduleTimingListState: state.getScheduleTimingList,
  saveScheduleTimingState: state.saveScheduleTiming,
  deleteScheduleTimeSlotState: state.deleteScheduleTimeSlot,
  getAllScheduleTimingListState: state.getAllScheduleTimingList,
});

const mapDispatchToProps = (dispatch) => ({
  getScheduleTimingList: (params) => dispatch(getScheduleTimingList(params)),
  saveScheduleTiming: (params) => dispatch(saveScheduleTiming(params)),
  saveScheduleTimingReset: () => dispatch(saveScheduleTimingReset()),
  deleteScheduleTimeSlot: (params) => dispatch(deleteScheduleTimeSlot(params)),
  deleteScheduleTimeSlotReset: () => dispatch(deleteScheduleTimeSlotReset()),
  getAllScheduleTimingList: (params) =>
    dispatch(getAllScheduleTimingList(params)),
  getAllScheduleTimingListReset: () =>
    dispatch(getAllScheduleTimingListReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Schedule);

// tag
// ?
// <ul className="events">
// {calSlots.map((item, i) => (
// 		<Space>
// 			<li key={item.content}>{timeSlotFormat(item.start_time)} - {timeSlotFormat(item.end_time)}</li>
// 		</Space>
// ))}
// </ul>
// :
// <div style={{color:'red'}}>

// </div>
